import Player from "@vimeo/player";

export default {
    methods: {
        initializeVimeoVideo(uuid, id) {
            const player = new Player(`vimeo-player-${uuid}${id}`, {
                url: `https://vimeo.com/${id.replace("?h=", "/")}`,
                portrait: false,
                title: false,
                byline: false,
                color: this.$settings('top_bar_background') ? this.$settings('top_bar_background').substring(1) : "#FFFFFF",
                pip: true,
            });

            // player.ad

            return player;
        },
    },
};
